import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider } from './auth/AuthContext';
import RequireAuth from './auth/RequireAuth';
import RequirePermission from './auth/RequirePermission';
import AppLayout from './components/layout/AppLayout';
import ToastContainer from './components/ui/Toast';
import Login from './pages/Login';
import NotFound from './pages/NotFound';
import { routes } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            {routes.map(({ path, perm, element }) => (
              <Route
                key={path}
                path={path}
                element={
                  <RequireAuth>
                    <AppLayout>
                      <RequirePermission perm={perm}>{element}</RequirePermission>
                    </AppLayout>
                  </RequireAuth>
                }
              />
            ))}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
        <ToastContainer />
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
